<template>
  <div class="singleImg" :style="`background-image: url('${src}')`"></div>
</template>

<script>
export default {
  name: 'SingleImage',

  props: {
    src: {
      type: String,
    },
    alt: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.singleImg {
  border-radius: 15px;
  overflow: hidden;
  max-width: 100%;
  background-size: cover;
  background-position: center;
}
</style>
